import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const RoutingFallbackStyled = styled.li<{
  isDragging?: boolean;
  marginTop: string;
}>`
  border-radius: 12px;
  border: dashed 1px
    ${(props) => {
      const isVaultVariant = props.theme.isVaultVariant;
      return isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default;
    }};
  z-index: 1;
  ${(props) => props.isDragging && `margin-top: ${props.marginTop};`}
`;

export const RoutingFallbackHeader = styled.div`
  display: flex;
  column-gap: 5px;
  padding: 20px;
  border-bottom: dashed 1px
    ${(props) => {
      const isVaultVariant = props.theme.isVaultVariant;
      return isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default;
    }};
`;

export const RoutingFallbackTitle = styled.h2`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleDisplayMedium
      : textStyleCss(theme.atlas.typography.semantic.headingH3);
  }}
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default;
  }};
  margin: 0;
`;

export const RoutingFallbackInfo = styled(StyledIcon)`
  cursor: pointer;
`;

export const RoutingFallbackBody = styled.div`
  display: flex;
  padding: 20px;
  column-gap: 20px;
`;

export const RoutingFallbackSubtitle = styled.h3`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body);
  }}
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default;
  }};
  margin: 0;
  margin-bottom: 10px;
`;

export const RoutingFallbackText = styled.p`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall);
  }}
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted;
  }};
  margin: 0;
  margin-bottom: 20px;
`;

export const RoutingFallbackRadioContainer = styled.div`
  margin-bottom: 20px;
`;

export const RoutingFallbackModalParagraph = styled.p`
  margin: 0;
  margin-bottom: 20px;
`;
